﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateActiveOrders = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const StatePaged_1 = require("../abstracts/StatePaged");
const gs_1 = require("@ivanlog/gs");
const StateOrder_1 = require("./StateOrder");
class StateActiveOrders extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageList, "Active orders", true);
    }
    start(args) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            var orders = yield this.lockgui(this.app.api.admin.activeManager.getActiveOrders(0, 0));
            yield this.fill(orders);
            return _super.start.call(this);
        });
    }
    fill(orders) {
        return __awaiter(this, void 0, void 0, function* () {
            this.page.ctrls.list.html = '';
            this.page.ctrls.btnNew.hide();
            for (const order of orders) {
                const item = new com.ListItem();
                item.ctrls.lType.text = "Order";
                item.ctrls.lId.text = `#${order.id}`;
                const fromLocation = order.route.locations[0];
                const toLocation = order.route.locations[order.route.locations.length - 1];
                let data = [gs.text.clearHtmlToText(`State: ${order.state}`),
                    gs.text.clearHtmlToText(`From: ${fromLocation.addressFull}`),
                    gs.text.clearHtmlToText(`To: ${toLocation.addressFull}`),
                    gs.text.clearHtmlToText(`Departure time: ${gs.date.getShortTime(order.route.departureTime)}`),
                ];
                if (!order.finalPrice)
                    data.push(gs.text.clearHtmlToText(`Est.price: ${order.estimatedPrice}`));
                else
                    data.push(gs.text.clearHtmlToText(`Final price: ${order.finalPrice}`));
                item.ctrls.pData.html = data.join('<br>');
                this.page.ctrls.list.append(item);
                item.onclick = () => gs_1.StateGS.Run(StateOrder_1.StateOrder, { id: order.id });
            }
        });
    }
}
exports.StateActiveOrders = StateActiveOrders;
StateActiveOrders.StateName = "activeOrders";
//# sourceMappingURL=StateActiveOrders.js.map